
/** 混入方法 ::: 
 *  @mixins mixFormConfig 表单项属性解构混入
 */
import { mixFormConfig } from "@/mixins/common/mix_form_config.js";
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name FormItemTemplate 子级组件混入
 *  @author 王汝鹏
 *  @version 2019-11-30
 */
export const mixFormItemTemplateChild = {
  mixins: [ mixFormConfig ],
  inject: [
    'form_item_template_store',
    'form_item_template_form_list_manager'
  ],
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} formMap 表单项字典
     */
    ...makeComputedGroup("form_item_template_store", {
      formMap: "formMap",
    }),
    /** 管理者说明 ::: 
     *  @return {Function} formListManager 表单项列表管理者
     */
    formListManager() { return this.form_item_template_form_list_manager; }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/form_item/mix_form_item_template_child.js